import { px2rem, useXScrollStyle, H10Bold, H8BoldStyle, B4RegularStyle } from '@moim/common';
import { Svg18AddG } from '@moim/icons';
import styled, { css } from 'styled-components';

var DateItemWidth = 30;
var DateItemMargin = 10;
var ItemWidth = DateItemWidth + DateItemMargin * 2;
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-wnc1-0"
})(["position:relative;width:100%;margin-top:", ";"], px2rem(3));
var ScrollContainer = styled.div.withConfig({
  displayName: "ScrollContainer",
  componentId: "sc-wnc1-1"
})(["display:flex;", ""], useXScrollStyle);
var EventDot = styled.div.withConfig({
  displayName: "EventDot",
  componentId: "sc-wnc1-2"
})(["width:", ";height:", ";margin-bottom:", ";border-radius:50%;background-color:", ";margin-bottom:", ";visibility:", ";"], px2rem(6), px2rem(6), px2rem(3), function (props) {
  return props.theme.colorV2.colorSet.grey700;
}, px2rem(4), function (props) {
  return props.$show ? "visible" : "hidden";
});
var DayText = styled(H10Bold).withConfig({
  displayName: "DayText",
  componentId: "sc-wnc1-3"
})(["width:100%;height:", ";text-align:center;"], px2rem(20));
var DateCircle = styled.div.withConfig({
  displayName: "DateCircle",
  componentId: "sc-wnc1-4"
})(["", " width:100%;height:", ";display:flex;align-items:center;justify-content:center;border-radius:", ";background-color:", ";color:", ";transition-property:background-color,color;transition-duration:200ms;transition-timing-function:ease-in-out;"], H8BoldStyle, px2rem(22), px2rem(4), function (props) {
  return props.$isSelected ? props.theme.colorV2.colorSet.grey1000 : "transparent";
}, function (props) {
  return props.$isSelected ? props.theme.colorV2.colorSet.white900 : "inherit";
});
var DateItemWrapper = styled.div.withConfig({
  displayName: "DateItemWrapper",
  componentId: "sc-wnc1-5"
})(["display:flex;flex-direction:column;align-items:center;min-width:", ";margin:0 ", ";cursor:pointer;user-select:none;color:", ";"], px2rem(DateItemWidth), px2rem(DateItemMargin), function (props) {
  return props.$isSelected ? props.theme.colorV2.colorSet.grey900 : props.theme.colorV2.colorSet.grey300;
});
var PlusIcon = styled(Svg18AddG).attrs(function (props) {
  return {
    size: "xs",
    iconColor: props.theme.colorV2.colorSet.grey600
  };
}).withConfig({
  displayName: "PlusIcon",
  componentId: "sc-wnc1-6"
})([""]);
var LoadMoreChip = styled.div.withConfig({
  displayName: "LoadMoreChip",
  componentId: "sc-wnc1-7"
})(["position:absolute;top:100%;transform:translateY(100%);border-radius:", ";background-color:", ";width:fit-content;padding:", " ", " ", " ", ";color:", ";", " display:flex;align-items:center;gap:", ";"], px2rem(16), function (props) {
  return props.theme.colorV2.colorSet.grey50;
}, px2rem(2), px2rem(6), px2rem(2), px2rem(8), function (props) {
  return props.theme.colorV2.colorSet.grey600;
}, B4RegularStyle, px2rem(10));
var LoadMoreContainer = styled.div.withConfig({
  displayName: "LoadMoreContainer",
  componentId: "sc-wnc1-8"
})(["min-width:50%;height:100%;display:flex;align-items:center;position:relative;", ""], function (props) {
  if (props.$position === "left") {
    return css(["padding-right:", ";justify-content:flex-end;"], px2rem(2));
  }
  return css(["padding-left:", ";justify-content:flex-start;"], px2rem(2));
});

export { Container, DateCircle, DateItemWrapper, DayText, EventDot, ItemWidth, LoadMoreChip, LoadMoreContainer, PlusIcon, ScrollContainer };
